(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-total-block"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.customElements || customElements.get('custom-total-block')) {
      return;
    }

    class CustomTotalBlock extends HTMLElement {
      constructor() {
        super();
        this.handleDocumentEvent = this.handleDocumentEvent.bind(this);
        this.handleVariantEvent = this.handleVariantEvent.bind(this);
        this.handleSectionLoad = this.handleSectionLoad.bind(this);
        this.pendingUpdate = null;
        this.variantUnsubscriber = null;
        this.quantityUnsubscriber = null;
      }

      connectedCallback() {
        this.priceElement = this.querySelector('[data-custom-total-block-price]');
        this.compareElement = this.querySelector('[data-custom-total-block-compare]');
        this.saveElement = this.querySelector('[data-custom-total-block-save]');
        this.noteElement = this.querySelector('[data-custom-total-block-note]');
        this.unitPriceElement = this.querySelector('[data-custom-total-block-unit-price]');
        this.quantityElement = this.querySelector('[data-custom-total-block-quantity]');
        this.unavailableElement = this.querySelector('[data-custom-total-block-unavailable]');
        this.variantData = this.readVariantData();
        this.refreshFormReferences();
        this.bindEvents();
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleDocumentEvent, true);
        document.removeEventListener('input', this.handleDocumentEvent, true);
        document.removeEventListener('click', this.handleDocumentEvent, true);
        document.removeEventListener('variant:change', this.handleVariantEvent);
        document.removeEventListener('variant-change', this.handleVariantEvent);
        document.removeEventListener('product:variant-change', this.handleVariantEvent);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);

        if (this.variantUnsubscriber) {
          this.variantUnsubscriber();
        }
        if (this.quantityUnsubscriber) {
          this.quantityUnsubscriber();
        }
        if (this.pendingUpdate) {
          window.clearTimeout(this.pendingUpdate);
        }
      }

      bindEvents() {
        document.addEventListener('change', this.handleDocumentEvent, true);
        document.addEventListener('input', this.handleDocumentEvent, true);
        document.addEventListener('click', this.handleDocumentEvent, true);
        document.addEventListener('variant:change', this.handleVariantEvent);
        document.addEventListener('variant-change', this.handleVariantEvent);
        document.addEventListener('product:variant-change', this.handleVariantEvent);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);

        let events = null;
        try {
          events = PUB_SUB_EVENTS;
        } catch (error) {
          events = null;
        }

        if (typeof subscribe === 'function' && events) {
          if (events.variantChange) {
            this.variantUnsubscriber = subscribe(events.variantChange, this.handleVariantEvent);
          }
          if (events.quantityUpdate) {
            this.quantityUnsubscriber = subscribe(events.quantityUpdate, () => this.scheduleUpdate());
          }
        }
      }

      readVariantData() {
        const script = this.querySelector('[data-custom-total-block-variants]');
        if (!script || !script.textContent.trim()) {
          return [];
        }

        try {
          const data = JSON.parse(script.textContent);
          return Array.isArray(data) ? data : [];
        } catch (error) {
          return [];
        }
      }

      refreshFormReferences() {
        this.productFormElement = null;
        this.form = null;

        const productFormId = this.dataset.productFormId;
        if (productFormId) {
          const element = document.getElementById(productFormId);
          if (element) {
            this.form = element.matches('form') ? element : element.querySelector('form');
            this.productFormElement = element.closest('product-form') || element;
          }
        }

        if (!this.form && this.dataset.formSelector) {
          const element = this.findBySelector(this.dataset.formSelector);
          if (element) {
            this.form = element.matches('form') ? element : element.querySelector('form');
            this.productFormElement = element.closest('product-form') || element;
          }
        }

        if (!this.form && this.dataset.sectionId) {
          const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
          const productForm = document.getElementById(`ProductForm-${this.dataset.sectionId}`);
          this.form = form && form.matches('form') ? form : productForm && productForm.querySelector('form');
          this.productFormElement = productForm || this.form && this.form.closest('product-form');
        }

        if (!this.form) {
          const closestProductForm = this.closest('product-form');
          this.form = closestProductForm ? closestProductForm.querySelector('form') : this.closest('form');
          this.productFormElement = closestProductForm || this.form && this.form.closest('product-form');
        }
      }

      findBySelector(selector) {
        if (!selector) {
          return null;
        }

        const scopes = [this.closest('section'), this.form, this.productFormElement, document].filter(Boolean);
        for (const scope of scopes) {
          try {
            const element = scope.querySelector(selector);
            if (element) {
              return element;
            }
          } catch (error) {
            return null;
          }
        }

        return null;
      }

      handleSectionLoad(event) {
        if (!event || !event.target || !event.target.contains(this)) {
          return;
        }

        this.variantData = this.readVariantData();
        this.refreshFormReferences();
        this.scheduleUpdate();
      }

      handleDocumentEvent(event) {
        if (!event || !event.target || !this.isRelevantTarget(event.target)) {
          return;
        }

        this.scheduleUpdate();
      }

      handleVariantEvent(event) {
        const payload = event && event.data ? event.data : event && event.detail ? event.detail : event;
        const data = payload && payload.data ? payload.data : payload;
        const sectionId = data && (data.sectionId || data.section_id);

        if (sectionId && this.dataset.sectionId && String(sectionId) !== String(this.dataset.sectionId)) {
          return;
        }

        const variant = data && (data.variant || data.currentVariant || data.selectedVariant);
        this.scheduleUpdate(variant || null);
      }

      scheduleUpdate(variant) {
        if (variant) {
          this.pendingVariant = variant;
        }

        if (this.pendingUpdate) {
          window.clearTimeout(this.pendingUpdate);
        }

        this.pendingUpdate = window.setTimeout(() => {
          this.pendingUpdate = null;
          const nextVariant = this.pendingVariant;
          this.pendingVariant = null;
          this.update(nextVariant || null);
        }, 0);
      }

      isRelevantTarget(target) {
        if (!(target instanceof Element)) {
          return false;
        }

        if (this.contains(target)) {
          return true;
        }

        if (this.form && this.form.contains(target)) {
          return true;
        }

        if (this.productFormElement && this.productFormElement.contains(target)) {
          return true;
        }

        const section = this.dataset.sectionId;
        if (section) {
          const scopedIds = [
            `ProductForm-${section}`,
            `product-form-${section}`,
            `Quantity-Form-${section}`,
            `quantity-breaks-${section}`,
            `variant-selects-${section}`
          ];

          for (const id of scopedIds) {
            const element = document.getElementById(id);
            if (element && element.contains(target)) {
              return true;
            }
          }
        }

        return this.safeClosest(target, this.dataset.variantInputSelector) || this.safeClosest(target, this.dataset.quantitySelector);
      }

      safeClosest(target, selector) {
        if (!selector) {
          return null;
        }

        try {
          return target.closest(selector);
        } catch (error) {
          return null;
        }
      }

      update(eventVariant) {
        this.refreshFormReferences();

        const variant = this.resolveVariant(eventVariant);
        const quantity = this.resolveQuantity();
        const multiplier = this.parseNumber(this.dataset.priceMultiplier, 1);
        const unitPrice = Math.round(this.parseNumber(variant && variant.price, this.parseNumber(this.dataset.fallbackPrice, 0)) * multiplier);
        const total = Math.round(unitPrice * quantity);
        const compareUnitPrice = this.resolveCompareUnitPrice(variant, multiplier);
        const compareTotal = Math.round(compareUnitPrice * quantity);
        const hasSavings = compareTotal > total;
        const savingsAmount = hasSavings ? compareTotal - total : 0;
        const savingsPercent = compareTotal > 0 ? Math.round((savingsAmount / compareTotal) * 100) : 0;
        const unavailable = variant && variant.available === false;

        this.dataset.currentVariantId = variant && variant.id ? String(variant.id) : this.dataset.fallbackVariantId || '';
        this.dataset.currentPrice = String(unitPrice);
        this.dataset.currentQuantity = String(quantity);
        this.dataset.currentTotal = String(total);

        if (this.priceElement) {
          this.priceElement.textContent = this.formatMoney(total);
        }
        if (this.compareElement) {
          this.compareElement.textContent = this.formatMoney(compareTotal);
          this.compareElement.hidden = this.dataset.showCompare !== 'true' || !hasSavings;
        }
        if (this.saveElement) {
          this.saveElement.textContent = this.formatTemplate(this.dataset.saveLabel || '', savingsAmount, savingsPercent, quantity);
          this.saveElement.hidden = this.dataset.showSaveBadge !== 'true' || !hasSavings;
        }
        if (this.noteElement) {
          this.noteElement.textContent = this.formatTemplate(this.dataset.giftNote || '', savingsAmount, savingsPercent, quantity);
          this.noteElement.hidden = this.dataset.showGiftNote !== 'true';
        }
        if (this.unitPriceElement) {
          this.unitPriceElement.textContent = this.formatMoney(unitPrice);
        }
        if (this.quantityElement) {
          this.quantityElement.textContent = String(quantity);
        }
        if (this.unavailableElement) {
          this.unavailableElement.hidden = !unavailable;
        }

        this.classList.toggle('is-unavailable', unavailable);
        if (this.dataset.hideIfUnavailable === 'true') {
          this.hidden = unavailable;
        }
      }

      resolveVariant(eventVariant) {
        if (eventVariant && eventVariant.id) {
          return eventVariant;
        }

        const variantId = this.resolveVariantId();
        if (variantId) {
          const matchingVariant = this.variantData.find((variant) => String(variant.id) === String(variantId));
          if (matchingVariant) {
            return matchingVariant;
          }
        }

        if (this.variantData.length) {
          const fallbackId = this.dataset.fallbackVariantId;
          const fallbackVariant = this.variantData.find((variant) => String(variant.id) === String(fallbackId));
          if (fallbackVariant) {
            return fallbackVariant;
          }
          return this.variantData[0];
        }

        return {
          id: variantId || this.dataset.fallbackVariantId,
          price: this.parseNumber(this.dataset.fallbackPrice, 0),
          available: true
        };
      }

      resolveVariantId() {
        const selector = this.dataset.variantInputSelector || 'input[name="id"]';
        const input = this.findScopedElement(selector);
        if (input && input.value) {
          return input.value;
        }

        if (this.dataset.sectionId) {
          const picker = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"], variant-radios[data-section="${this.dataset.sectionId}"]`);
          if (picker && picker.currentVariant && picker.currentVariant.id) {
            return picker.currentVariant.id;
          }
        }

        const params = new URLSearchParams(window.location.search);
        return params.get('variant') || this.dataset.fallbackVariantId || '';
      }

      resolveCompareUnitPrice(variant, multiplier) {
        if (this.dataset.compareSource === 'none') {
          return 0;
        }

        if (this.dataset.compareSource === 'manual') {
          return Math.round(this.parseNumber(this.dataset.manualComparePrice, 0) * multiplier);
        }

        const price = this.parseNumber(variant && variant.price, 0);
        const compareAt = this.parseNumber(variant && variant.compare_at_price, 0);
        return compareAt > price ? Math.round(compareAt * multiplier) : 0;
      }

      resolveQuantity() {
        const min = this.parseNumber(this.dataset.minQuantity, 1);
        const max = this.parseNumber(this.dataset.maxQuantity, 0);
        let quantity = null;

        if (this.dataset.sectionId) {
          const quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
          if (quantityBreaks && quantityBreaks.selectedQuantity) {
            quantity = quantityBreaks.selectedQuantity;
          }
        }

        if (quantity === null && this.dataset.quantitySelector) {
          const selected = this.findSelectedQuantity(this.dataset.quantitySelector);
          if (selected !== null) {
            quantity = selected;
          }
        }

        if (quantity === null) {
          quantity = this.findSelectedQuantity('input[name="quantity"]');
        }

        if (quantity === null) {
          quantity = this.findSelectedQuantity('.quantity__input');
        }

        if (quantity === null) {
          quantity = this.parseNumber(this.dataset.fallbackQuantity, min);
        }

        quantity = Math.max(min, this.parseNumber(quantity, min));
        if (max > 0) {
          quantity = Math.min(max, quantity);
        }

        return quantity;
      }

      findSelectedQuantity(selector) {
        const scopes = [this.form, this.productFormElement, this.closest('section'), document].filter(Boolean);

        for (const scope of scopes) {
          let elements = [];
          try {
            elements = Array.from(scope.querySelectorAll(selector));
          } catch (error) {
            return null;
          }

          const checked = elements.find((element) => (element.type === 'radio' || element.type === 'checkbox') && element.checked);
          const element = checked || elements.find((candidate) => candidate.type !== 'hidden' && !candidate.disabled);
          if (element && element.value !== '') {
            return element.value;
          }
        }

        return null;
      }

      findScopedElement(selector) {
        const scopes = [this.form, this.productFormElement, this.closest('section'), document].filter(Boolean);

        for (const scope of scopes) {
          try {
            const element = scope.querySelector(selector);
            if (element) {
              return element;
            }
          } catch (error) {
            return null;
          }
        }

        return null;
      }

      parseNumber(value, fallback) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      formatTemplate(template, amount, percent, quantity) {
        return String(template)
          .replace(/\[amount\]/g, this.formatMoney(amount))
          .replace(/\[percent\]/g, String(percent))
          .replace(/\[quantity\]/g, String(quantity));
      }

      formatMoney(cents) {
        const defaultFormat = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
        const format = this.dataset.moneyFormat || defaultFormat;
        const trimZeroDecimals = this.dataset.trimZeroDecimals === 'true';
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholder);
        const token = match ? match[1] : 'amount';
        const value = this.formatMoneyValue(cents, token, trimZeroDecimals);

        return format.replace(placeholder, value);
      }

      formatMoneyValue(cents, token, trimZeroDecimals) {
        const amount = Number(cents) / 100;
        const formatWithSeparators = (decimals, thousands, decimal) => {
          const fixed = amount.toFixed(decimals);
          const parts = fixed.split('.');
          const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          const centsPart = parts[1] ? `${decimal}${parts[1]}` : '';
          return trimZeroDecimals && centsPart === `${decimal}00` ? dollars : `${dollars}${centsPart}`;
        };

        switch (token) {
          case 'amount_no_decimals':
            return formatWithSeparators(0, ',', '.');
          case 'amount_with_comma_separator':
            return formatWithSeparators(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithSeparators(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithSeparators(2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return formatWithSeparators(0, ' ', '.');
          case 'amount_with_space_separator':
            return formatWithSeparators(2, ' ', '.');
          default:
            return formatWithSeparators(2, ',', '.');
        }
      }
    }

    customElements.define('custom-total-block', CustomTotalBlock);
  })();
  } catch(e) { console.error(e); }
})();

})();
